'use client';

import { BellRing, CheckCircle, AlertTriangle, Send } from 'lucide-react';
import { StatsCard } from '@/core/presentation/components/StatsCard';
import { kpiData, reminderFunnelData } from '@/features/admin/presentation/data/mockData';
import { motion } from 'framer-motion';

export function DashboardLembretes() {
  const maxFunnel = reminderFunnelData[0].value;

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <StatsCard
          title="Total"
          value={kpiData.totalReminders.toLocaleString('pt-BR')}
          icon={<BellRing className="h-5 w-5 text-admin-cyan-dark" />}
          gradient
        />
        <StatsCard
          title="Futuros"
          value={kpiData.futureReminders.toLocaleString('pt-BR')}
          icon={<Send className="h-5 w-5 text-admin-cyan-dark" />}
          trend={9.4}
        />
        <StatsCard
          title="Falhas"
          value={kpiData.reminderFailures.toLocaleString('pt-BR')}
          icon={<AlertTriangle className="h-5 w-5 text-admin-cyan-dark" />}
          trend={-4.5}
        />
        <StatsCard
          title="Taxa de sucesso"
          value={`${kpiData.reminderSuccessRate}%`}
          icon={<CheckCircle className="h-5 w-5 text-admin-cyan-dark" />}
          trend={1.2}
        />
      </div>

      <div className="bg-white rounded-xl border border-admin-border p-5 shadow-sm">
        <div className="flex items-center justify-between mb-5">
          <h3 className="text-sm font-semibold text-admin-text">Funil operacional de lembretes</h3>
          <span className="text-xs font-medium text-admin-text-secondary">
            Canal de envio: WhatsApp
          </span>
        </div>
        <div className="space-y-3 max-w-2xl">
          {reminderFunnelData.map((stage, i) => {
            const pct = (stage.value / maxFunnel) * 100;
            const convRate =
              i > 0 ? ((stage.value / reminderFunnelData[i - 1].value) * 100).toFixed(1) : '100';

            return (
              <div key={stage.stage} className="space-y-1">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-admin-text font-medium">{stage.stage}</span>
                  <span className="text-admin-text-secondary">
                    {stage.value.toLocaleString('pt-BR')}
                    {i > 0 && (
                      <span className="ml-2 text-xs text-admin-cyan-dark">({convRate}%)</span>
                    )}
                  </span>
                </div>
                <div className="h-8 bg-admin-bg-block rounded-lg overflow-hidden">
                  <motion.div
                    initial={{ width: 0 }}
                    animate={{ width: `${pct}%` }}
                    transition={{ duration: 0.6, delay: i * 0.1 }}
                    className="h-full rounded-lg"
                    style={{
                      background:
                        'linear-gradient(90deg, #0D1B5E 0%, #1A2E7A 50%, #4AB8E0 100%)',
                    }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

